import { AxiosError } from 'axios';

import { TRANSFER_CONSULTANT_CANDIDATE_DATA_API_URL } from '@/constants/apis';
import { configuration } from '@/constants/config.ts';
import { apiManager } from '@/helpers/api.manager';
import { ApiResponse } from '@/types/response.type';

export type TransferConsultantCandidateDataRequest = {
  zor_id: string;
  emailAddress: string;
  consultantId: string;
};

export type TransferConsultantCandidateDataResponse = {
  message: string;
  dataTransferred: boolean;
};

export const transferConsultantCandidateData = async (
  payload: TransferConsultantCandidateDataRequest
): Promise<ApiResponse<TransferConsultantCandidateDataResponse>> => {
  try {
    const response = await apiManager.post(
      TRANSFER_CONSULTANT_CANDIDATE_DATA_API_URL,
      payload,
      {
        baseURL: configuration.CLERK_API_URL,
        headers: { 'Content-Type': 'application/json' },
      }
    );

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};
